// import * as icons from "@material-ui/icons";
import { Paper } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Table, TableBody, TableCell, TableHead, TableRow } from '../../components/Table';
import TablePagination, { IPageEvent } from '../../components/TablePagination/TablePagination';
import { IPaginationMetaResponse, IPaginationParams } from '../../libs/quickjobs-api';
import { fetchFeedbackRequest, IFeedbackFetchRequestAction } from '../../store/actions/feedback';
import { IFeedback, IFeedbackState } from '../../store/types/feedback';

class FeedbackSummary extends React.Component<IProps, { limit: number }> {
  private static readonly DEFAULT_LIMIT = 10;

  public state = {
    limit: FeedbackSummary.DEFAULT_LIMIT,
  };

  public componentDidMount() {
    this.props.fetchFeedback({ limit: this.state.limit });
  }

  public handlePagination() {
    return (event: IPageEvent, limit: number) => {
      this.setState({ limit });
      switch (event) {
        case IPageEvent.FIRST_PAGE:
          this.props.fetchFeedback({
            limit: limit,
          });
          break;
        case IPageEvent.BACK:
          const firstFeedback: IFeedback = this.props.feedback[0];
          this.props.fetchFeedback({
            since: firstFeedback.created_at,
            limit: limit,
          });
          break;
        case IPageEvent.NEXT:
          const lastFeedback: IFeedback = this.props.feedback[this.props.feedback.length - 1];
          this.props.fetchFeedback({
            until: lastFeedback.created_at,
            limit: limit,
          });
          break;
      }
    };
  }

  public render() {
    const rows = this.props.feedback as IFeedback[];
    const meta = this.props.meta;

    return (
      <Paper>
        {rows.length ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell numeric={true}>ID</TableCell>
                <TableCell>User</TableCell>
                <TableCell numeric={true}>Rating</TableCell>
                <TableCell>Message</TableCell>
                <TableCell>Created</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map(r => {
                return (
                  <TableRow key={r.id} hover={true}>
                    <TableCell numeric={true}>{r.id}</TableCell>
                    <TableCell>
                      {r.user ? `${r.user.given_name} ${r.user.family_name}` : 'Anonymous'}
                    </TableCell>
                    <TableCell numeric={true}>{r.rating}</TableCell>
                    <TableCell>{r.message}</TableCell>
                    <TableCell>{new Date(r.created_at).toLocaleString('cs-CZ')}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        ) : null}
        {meta ? (
          <TablePagination
            hasPreviousPage={meta.has_previous}
            hasNextPage={meta.has_next}
            onChangePage={this.handlePagination()}
            defaultLimit={this.state.limit}
          />
        ) : null}
      </Paper>
    );
  }
}

interface IProps {
  feedback: IFeedback[];
  meta: IPaginationMetaResponse;
  fetchFeedback: (params?: IPaginationParams) => IFeedbackFetchRequestAction;
}

const mapStateToProps = (state: { feedback: IFeedbackState }) => {
  return {
    feedback: state.feedback.feedback,
    meta: state.feedback.meta,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    fetchFeedback: (params?: IPaginationParams) => dispatch(fetchFeedbackRequest(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FeedbackSummary);



// WEBPACK FOOTER //
// ./src/screens/Feedback/Feedback.tsx